export default __webpack_public_path__ + "static/media/inspeq.6e9fa7b1.jpg";